import { writable } from 'svelte/store'

const _productDataStore = writable({})

function setSelectedColour (productType, colour) {
  _productDataStore.update(productData => {
    productData[productType].selectedColour = colour
    return productData
  })
}

function deleteProduct (productType) {
  _productDataStore.update(productData => {
    productData[productType] = null
    return productData
  })
}

export const productDataStore = {
  subscribe: _productDataStore.subscribe,
  set: _productDataStore.set,
  update: _productDataStore.update,
  setSelectedColour,
  deleteProduct
}
